import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    typeLists: []
};
const getters = {
    costType: state => state.typeLists

};

const mutations = {
    CONTACT_TYPE_INFO(state, data) {
        state.typeLists = data
    }
};

const actions = {
    costType(context) {
        axiosGet(`crm/cost/types`).then((response) => {
            context.commit('CONTACT_TYPE_INFO', response.data.data)
        }).catch((error) => console.log(error));
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}
